import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import InternetLobbyHeaderData from 'app/Models/Content/InternetLobbyHeaderData';
import {getVideoLink, getImageProps} from 'app/utilities/ImageProps';
import BackgroundVideo from '../../Page/TVLobbyPage/BackgroundVideo';
import {isMobile} from 'react-device-detect';
import {Container} from 'reactstrap';

import React from 'react';
import TagName from 'app/Components/Shared/TagName';

const InternetLobbyHeader = ({data, context}: ComponentProps<InternetLobbyHeaderData>) => {
  const {fadeClass, ref} = useFadeIn();
  const videoUrl = data.mobileVideo.value || data.video.value ? getVideoLink(isMobile ? data.mobileVideo : data.video, context) : null;
  const imageUrl =
    data.mobileImage.expandedValue || data.image.expandedValue ? getImageProps(isMobile ? data.mobileImage : data.image, context) : null;

  function Navigate() {
    if (data.headerButtonLink.value != null) context.navigateTo(data.headerButtonLink.value);
    else {
      context.navigateTo('');
    }
  }

  var isShowHeaderButton = data.isShowHeaderButton.value;
  var designModeNumber = -1;
  var designText = 'להצטרפות';

  if (isShowHeaderButton) {
    if (data.blockButton.expandedValue[0] != null) {
      designText = (data.blockButton.expandedValue[0] as any).text.value;
      designModeNumber = (data.blockButton.expandedValue[0] as any).buttonDesignMode.value;
    }
  }

  if (!isShowHeaderButton) designText = '';

  const getButtonClassByName = (designIndex) => {
    let name = '';
    switch (designIndex) {
      case 0:
        name = 'purple-button';
        break;
      case 1:
        name = 'black-button';
        break;
      case 2:
        name = 'white-button';
        break;
      case -1:
        name = 'HeadButton__button-container__button';
    }

    return name;
  };
  return (
    <div ref={ref} className={`InternetLobbyHeader ${fadeClass}`}>
      <BackgroundVideo videoUrl={videoUrl} fallbackImageProps={imageUrl} />
      <Container>
        <div className='InternetLobbyHeader__title-and-subtitle'>
          <TagName
            tagName={data.titleHeadlineTag?.value ? data.titleHeadlineTag?.value : 2}
            isTitle
            className='InternetLobbyHeader__title-and-subtitle__title'>
            {data.title?.value}
          </TagName>
     
          <TagName
            tagName={data.subtitleHeadlineTag?.value ? data.subtitleHeadlineTag.value : 7}
            className='InternetLobbyHeader__title-and-subtitle__subtitle'>
            {data.subtitle?.value}
            <div className='Button'>
        <div className='Button__button-container'>
          <a
            className={isShowHeaderButton ? `Button__button-container__button ${getButtonClassByName(designModeNumber)}` : null}
            href='#'
            onClick={Navigate}>
            {designText}
          </a>
        </div>
      </div>
          </TagName>
        </div>
      </Container>
      
    </div>
    
    

  );
};

export default InternetLobbyHeader;
